import { render, staticRenderFns } from "./ClaimAccount.vue?vue&type=template&id=4418dcd8&"
import script from "./ClaimAccount.vue?vue&type=script&lang=js&"
export * from "./ClaimAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports